import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-pages',
  templateUrl: './ui-pages.component.html',
  styleUrls: ['./ui-pages.component.scss']
})
export class UIPagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
